import { useState, useEffect } from 'react';

export const useAnchorParams = () => {
  const [el, setEl] = useState<HTMLElement | null>(null);

  const getEl = () => {
    if (el) {
      let style: any = getComputedStyle(el);
      let radius = getComputedStyle(el.firstElementChild || el).borderRadius;
      let zoom = parseFloat(style.zoom) || 1;

      return {
        width: `${parseFloat(style.width) * zoom}px`,
        top: parseFloat(style.top) * zoom,
        left: `${parseFloat(style.left) * zoom}px`,
        height: parseFloat(style.height) * zoom,
        borderRadius: `${parseFloat(radius) * zoom}px`,
      };
    }

    return null;
  };

  const [offsetEl, setOffsetEl] = useState(getEl());

  useEffect(() => {
    let interval: NodeJS.Timer | null = null;

    if (process.env.REACT_APP_MENU_BLOCK) {
      interval = setInterval(() => {
        const queryEl = document.getElementsByClassName(
          process.env.REACT_APP_MENU_BLOCK || ''
        )[0] as HTMLElement | null;

        if (queryEl) {
          setEl(queryEl);

          if (interval) {
            clearInterval(interval);
          }
        }
      }, 100);
    }

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, []);

  useEffect(() => {
    if (!el) {
      return;
    }

    setOffsetEl(getEl());

    let observer = new MutationObserver(() => {
      setOffsetEl(getEl());
    });
    const config = {
      attributes: true,
    };

    if (el) {
      observer.observe(el, config);
    }

    return () => {
      observer.disconnect();
    };
  }, [el]);

  return { offsetEl };
};
